import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormBuilder, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';

@Component({
    selector: 'app-rating-selector',
    templateUrl: './rating-selector.component.html',
    styleUrls: ['./rating-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SharedModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RatingSelectorComponent),
            multi: true
        }
    ]
})
export class RatingSelectorComponent implements ControlValueAccessor {
  public readonly starsAmountIndicator = new Array( 1, 2, 3, 4, 5 );

  public isDisabled: boolean;

  public value?: number;

  constructor(private fb: FormBuilder) {
  }

  public onChange: any = () => {
  };

  public onTouch: any = () => {
  };

  public change(): void {
    this.onChange(this.value);
    this.onTouch(this.value);
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public writeValue(value: number): void {
    this.value = value;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public selectStar(value: number): void {
    this.value = value;
    this.writeValue(value);
    this.change();
  }
}
